import type { MouseEvent } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  stopPropagation?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function Checkbox({
  checked,
  onChange,
  stopPropagation,
  className,
  'aria-label': ariaLabel,
}: CheckboxProps) {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) e.stopPropagation();
    onChange();
  };
  return (
    <button
      type="button"
      role="button"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={handleClick}
      className={cn(
        'w-[14px] h-[14px] rounded-sm p-0 inline-flex items-center justify-center transition-colors duration-100 cursor-pointer',
        checked
          ? 'bg-[var(--fm-accent)] border-[1.5px] border-[var(--fm-accent)] text-white'
          : 'bg-white border-[1.5px] border-borderStrong hover:border-[var(--fm-accent)]',
        className
      )}
    >
      {checked && <Check size={9} strokeWidth={3} />}
    </button>
  );
}

Checkbox.displayName = 'Checkbox';

export default Checkbox;
